import { useRouter } from 'next/router';

import { addQueryToRecentSearches } from 'src/utils/recentSearchesFromLocalStorage';

import SearchCombobox from 'components/BaseHelpers/SearchCombobox';
import { getTypeaheadResultsFactory } from 'components/Core/CoreGlobalNavigationHeader/components/SearchInput/getTypeaheadResult';

import { peopleTypeaheadValueSchema } from '../../utils';

export type PeopleSearchComboboxProps = {
  placeholder: string;
  recentSearchesLabel: string;
  className?: string;
  queryDraft: string;
  typeaheadResultsCount: number;
  setQueryDraft: (query: string) => void;
  submitQuery: (query: string) => void;
};

const PeopleSearchCombobox = (props: PeopleSearchComboboxProps): JSX.Element => {
  const {
    placeholder,
    recentSearchesLabel,
    className,
    queryDraft,
    typeaheadResultsCount,
    setQueryDraft,
    submitQuery,
  } = props;
  const router = useRouter();
  const localStorageKey = 'peopleLandingRecentSearches';

  const handleSubmit = (query: string) => {
    addQueryToRecentSearches(
      {
        title: query,
        value: JSON.stringify({ title: query, href: '', type: 'query' }),
      },
      localStorageKey
    );
    setQueryDraft(query);
    submitQuery(query);
  };

  return (
    <SearchCombobox
      className={className}
      getTypeaheadResult={getTypeaheadResultsFactory('/api/people-search/typeahead')}
      inputValue={queryDraft}
      localStorageKey={localStorageKey}
      onInputValueChange={setQueryDraft}
      onSubmit={handleSubmit}
      placeholder={placeholder}
      recentSearchesLabel={recentSearchesLabel}
      typeaheadResultsCount={typeaheadResultsCount}
      onSelect={(e) => {
        const result = peopleTypeaheadValueSchema.safeParse(JSON.parse(e.itemValue));
        if (!result.success) {
          console.error('Invalid typeahead value:', result.error);
          return;
        }
        const { href, title, type } = result.data;
        if (type === 'query') {
          handleSubmit(title);
          return;
        } else if (type === 'link') {
          router.push(href);
        } else {
          const never: never = type;
          return never;
        }
      }}
    />
  );
};

export default PeopleSearchCombobox;
